import { render, staticRenderFns } from "./MenuControls.vue?vue&type=template&id=4567a01d&scoped=true&"
import script from "./MenuControls.vue?vue&type=script&lang=js&"
export * from "./MenuControls.vue?vue&type=script&lang=js&"
import style0 from "./MenuControls.vue?vue&type=style&index=0&id=4567a01d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4567a01d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4567a01d')) {
      api.createRecord('4567a01d', component.options)
    } else {
      api.reload('4567a01d', component.options)
    }
    module.hot.accept("./MenuControls.vue?vue&type=template&id=4567a01d&scoped=true&", function () {
      api.rerender('4567a01d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/MenuArea/MenuControls.vue"
export default component.exports